import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const ScopeOfPracticeWrapper = styled(Box)(({ theme }) => ({
  paddingTop: '60px',
  [theme.breakpoints.down('md')]: {
    paddingTop: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: '30px',
  },
}));
